import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./ServiceItem.css";

const ServiceItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "infrastructure-service-list-item": true,
    "u-selected": props.selected,
    "u-running": data.get("status") === "running"
  })

  let tags = data.get("tags").join(", ")

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-description">
        <span className="title">{data.get("title")}</span>
        {data.get("description")}
        <span className="id">{data.get("serviceId")}</span>
        <div className="tags">tags: {tags}</div>
      </td>
      <Status status={data.get("status")} />
    </tr>
  )
}

function Status({status}) {
  let parts = status.split(":");
  let statusPart = parts[0];

  let overridden = (parts[1] || "") === "disabled";
  let title = statusPart;
  if (statusPart === "not_running") title = "Not Running";
  if (statusPart === "running") title = "Running"
  if (statusPart === "disabled") title = "Disabled"

  let classes = cx({
    "field": true,
    "f-status": true,
    "f-override": overridden
  })

  return (
    <td className={classes}>{title}</td>
  )
}

export default ServiceItem;